import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import '../../styles/mission-statement.css';

const MissionStatement: React.FC = () => {
  const { t } = useTranslation('landing');
  const rootRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const el = rootRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry?.isIntersecting) {
          el.classList.add('ms-visible');
          observer.disconnect();
        }
      },
      { threshold: 0.3 },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="mission-statement" ref={rootRef} aria-label="Mission statement">
      <div className="mission-rule" aria-hidden="true" />

      <div className="mission-content">
        <h2 className="mission-headline">
          {t('shopUi.missionHeadline')}
        </h2>

        <div className="mission-dots" aria-hidden="true">
          <span className="mission-dot mission-dot--side" />
          <span className="mission-dot mission-dot--center" />
          <span className="mission-dot mission-dot--side" />
        </div>

        <p className="mission-subtitle">
          {t('shopUi.missionSub1')}
          <br />
          {t('shopUi.missionSub2')}
        </p>
      </div>

      <div className="mission-rule" aria-hidden="true" />
    </section>
  );
};

export default MissionStatement;
